import { useSelector } from "react-redux";
import { useCallback } from "react";
import { selectProjects } from "../stores/projectSlice";

export const useAppUtils = () => {
    const allProjects = useSelector(selectProjects);
    
    const getProjectName = useCallback((code) => {
        if (!code) return "";
        const project = allProjects.find(item => item.PROJECT_CODE === code);
        return project?.PROJECT_NAME || code;
    }, [allProjects]);

    return { getProjectName, allProjects };
}
